import React from 'react';
import { ChromePicker } from 'react-color';
import { Box, List, ListItem, Button, Popover, FormControlLabel, FormGroup, Switch, IconButton, ListItemAvatar, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import Stack from './Stack';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SectionHeading from './SectionHeading';
import { withStyles } from '@material-ui/core/styles';
import { yellow, grey } from '@material-ui/core/colors';





const THEME_DEFINITION = {
    colors: [
        { code: 'COLOR_PRIMARY', name: 'Primary Color', defaultValue: '#D1517A', order: 1, textColor : '#fff', subHeading : 'Features on white pages (updates headings and buttons)' },
        { code: 'COLOR_SECONDARY', name: 'Secondary Color', defaultValue: '#FFE916', order: 2, textColor : '#434F69', subHeading : 'Top navigation, page headers (clue + end), and features on blue challenge pages (updates headings and buttons)' },
        { code: 'SPARK_CHALLANGE_BACKGROUND', name: 'Background Color', defaultValue: '#434F69', order: 3, textColor : '#fff', subHeading : 'Spark challenge and provider item background color' }
    ]
}

const DEFAULT_THEME = {
    isEnabled: false,
    colors: THEME_DEFINITION.colors.sort((c1, c2) => c1.order < c2.order).map(c => ({
        code: c.code,
        value: c.defaultValue,
    }))
}

export default function ThemeDesigner({ theme, onUpdateTheme }) {
    let isThemeEnabled = Boolean(theme?.isEnabled);
    function themeColorsUpdated(colors) {
        onUpdateTheme({ ...theme, colors: [...colors] })
    }

    function toggleThemeEnabled(event) {
        if (theme?.isEnabled) {
            onUpdateTheme(null);
        } else {
            onUpdateTheme({ ...DEFAULT_THEME, isEnabled: true });
        }
    }

    return (
        <Stack>
            <SectionHeading>Theme</SectionHeading>
            <FormGroup>
                <Box style={{ display : 'flex', flex : 1, justifyContent : 'space-between'}}>
                Colour palette
                <FormControlLabel
                    control={<YellowSwitch size="small" checked={isThemeEnabled} onChange={toggleThemeEnabled} />}
                    label={''}
                /></Box>
            </FormGroup>
            {!!theme?.isEnabled && <Stack>
            <ColorPickerList colors={theme?.colors} onUpdateColors={themeColorsUpdated} />
        </Stack>
    }
        </Stack >
    )
}


export function ColorPickerList({ colors: themeColorList, onUpdateColors }) {
    function colorUpdated(color) {
        onUpdateColors(themeColorList.map(c => c.code === color.code ? color : c))
    }

    return (
        <Box>
            <List >
                {THEME_DEFINITION.colors.sort((c1, c2) => c1.order < c2.order)
                    .map(def => {
                        const color = themeColorList.find(c => c.code === def.code) || { code: def.code, value: def.defaultValue }
                        return (<ColorPickerRow key={color.code} code={color.code} value={color.value} textColor={def.textColor} onUpdateColor={colorUpdated} defaultValue={def.defaultValue} />)
                    })}
            </List>


        </Box>

    )

}


function ColorPickerRow({ code, value, defaultValue, textColor, onUpdateColor }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [activeColorValue, setActiveColorValue] = React.useState(value);
    const open = Boolean(anchorEl);

    function onPickerChange(pickerColor, event) {
        setActiveColorValue(pickerColor.hex)
    }

    function getColorName(code) {
        return THEME_DEFINITION.colors.find(c => c.code === code)?.name || 'INVALID_COLOR_DEF'
    }
    
    function getSubheading(code) {
        return THEME_DEFINITION.colors.find(c => c.code === code)?.subHeading || 'INVALID_COLOR_DEF'
    }
    
    const menuClicked = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (event) => {
        // not sure why we need stopPopogation here, but without it the acnhorEl never gets reset 
        // and the page stops responding to clicks. 
        event.stopPropagation();
        setAnchorEl(null);
    };

    function defaultClicked(event) {
        onUpdateColor({ code, value: defaultValue })
        handleMenuClose(event);
    }

    function saveClicked(event) {
        onUpdateColor({ code, value: activeColorValue })
        handleMenuClose(event);
    }

  
    return (
        <ListItem style={{ cursor: 'pointer' }} >
            <ListItemAvatar onClick={menuClicked}>
                <Box style={{ borderRadius: '6px', width: '30px', height: '30px', marginRight: '12px', backgroundColor: value, color: textColor, verticalAlign : 'center', lineHeight : '30px', textAlign : 'center', fontSize : 'large', fontWeight : 'bolder' }} >A</Box>
            </ListItemAvatar>
            <ListItemText style={{ fontFamily: "gilroy-regular"}} primary={getColorName(code)} secondary={getSubheading(code)}/>
            
            
            
            <ListItemSecondaryAction>
                <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={menuClicked}
                >
                    <MoreVertIcon />
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                    >

                        <Stack>
                            <Box style={{ display: 'flex', flex: 1, justifyContent: 'space-between', marginBottom: '4px' }}>
                                <Button variant='contained' onClick={saveClicked} disabled={activeColorValue === value}><ButtonSwatch color={activeColorValue} />Update</Button>
                                <Button variant='contained' onClick={defaultClicked} disabled={activeColorValue === defaultValue}><ButtonSwatch color={defaultValue} />Default</Button>
                            </Box>

                            <ChromePicker color={activeColorValue} onChange={onPickerChange} disableAlpha={true}></ChromePicker>
                        </Stack>
                    </Popover>
                </IconButton>
            </ListItemSecondaryAction>

        </ListItem>

    )
}


function ButtonSwatch({ color: colorValue }) {
    return (
        <Box style={{ height: '12px', width: '12px', marginRight: '8px', border: '1px dashed #ccc', backgroundColor: colorValue }} />
    )

}


const YellowSwitch = withStyles({
    switchBase: {
      color: grey[300],
      '&$checked': {
        color: yellow[500],
      },
      '&$checked + $track': {
        backgroundColor: yellow[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);
  